import { EntityAttributes } from "../../interfaces/EntityAttributes.interface"
import { JourneyDocument } from "../../interfaces/JourneyDocument.interface"
import { JourneyDocumentRequirements } from "../../interfaces/JourneyDocumentRequirements"
import { JourneyTaskAttributes } from "../../interfaces/JourneyTaskAttributes.interface"
import { ILookupViewModel } from '../../interfaces/LookupModels'
import { EntityDraftViewModel } from '../../interfaces/EntityDraftViewModel'
import { PeopleEntityModel } from "../../interfaces/PeopleEntityModel.interface"
import { AssociationModel } from "../../interfaces/AssociationModel.interface"
import { IRequirementViewModel } from "../../interfaces/RequirementsInScopeModel";

export enum EntityActionTypeEnum {
  SET_ENTITIES_LOAD_IN_PROGRESS = "SET_ENTITIES_LOAD_IN_PROGRESS",
  SET_ENTITIES = "SET_ENTITIES",
  SET_SELECTED_ENTITY = "SET_SELECTED_ENTITY",
  SET_JOURNEY_TASKS_LOAD_IN_PROGRESS = "SET_JOURNEY_TASKS_LOAD_IN_PROGRESS",
  SET_INITIAL_JOURNEY_TASKS = "SET_INITIAL_JOURNEY_TASKS",
  SET_LATEST_JOURNEY_TASKS = "SET_LATEST_JOURNEY_TASKS",
  SET_SELECTED_JOURNEY_TASK = "SET_SELECTED_JOURNEY_TASK",
  SET_DATA_GROUPS = "SET_DATA_GROUPS",
  SET_DATA_GROUPS_LOAD_IN_PROGRESS = "SET_DATA_GROUPS_LOAD_IN_PROGRESS",
  SET_DOCUMENTS_LOAD_IN_PROGRESS = "SET_DOCUMENTS_LOAD_IN_PROGRESS",
  SET_DOCUMENTS = "SET_DOCUMENTS",
  SET_DOCUMENT_REQUIREMENTS = "SET_DOCUMENT_REQUIREMENTS",
  SET_DOCUMENT_REQUIREMENTS_LOAD_IN_PROGRESS = "SET_DOCUMENT_REQUIREMENTS_LOAD_IN_PROGRESS",
  SET_DOCUMENT_DOWNLOAD_URL = "SET_DOCUMENT_DOWNLOAD_URL",
  SET_DOCUMENT_DOWNLOAD_URL_LOAD_IN_PROGRESS = "SET_DOCUMENT_DOWNLOAD_URL_LOAD_IN_PROGRESS",
  SET_ENTITY_DRAFT = "SET_ENTITY_DRAFT",
  SET_ENTITY_DRAFT_LOAD_IN_PROGRESS = "SET_ENTITY_DRAFT_LOAD_IN_PROGRESS",
  SET_LOOKUPS = "SET_LOOKUPS",
  SET_CODAT_INTEGRATION="SET_CODAT_INTEGRATION",
  SET_LOOKUPS_LOAD_IN_PROGRESS = "SET_LOOKUP_LOAD_IN_PROGRESS",
  SET_CODAT_INTEGRATION_LOAD_IN_PROGRESS="SET_CODAT_INTEGRATION_LOAD_IN_PROGRESS",
  SET_LOOKUP_LINKS = "SET_LOOKUP_LINKS",
  SET_LOOKUP_LINKS_LOAD_IN_PROGRESS = "SET_LOOKUP_LINKS_LOAD_IN_PROGRESS",
  SET_INITITAL_REQUIREMENTS = "SET_INITITAL_REQUIREMENTS",
  SET_INITITAL_REQUIREMENTS_LOAD_IN_PROGRESS = "SET_INITITAL_REQUIREMENTS_LOAD_IN_PROGRESS",
  SET_ASSOCIATIONS = "SET_ASSOCIATIONS",
  SET_ASSOCIATIONS_LOAD_IN_PROGRESS = "SET_ASSOCIATIONS_LOAD_IN_PROGRESS",
  SET_PEOPLE_ENTITIES_LIST = "SET_PEOPLE_ENTITIES_LIST",
  SET_PEOPLE_ENTITIES_LIST_LOAD_IN_PROGRESS = "SET_PEOPLE_ENTITIES_LIST_LOAD_IN_PROGRESS",
  SET_ALL_PEOPLE_ENTITIES_LIST = "SET_ALL_PEOPLE_ENTITIES_LIST",
  SET_ENTITY = "SET_ENTITY",
  SET_VERIFY_ENTITY_INFORMATION_OPEN = "SET_VERIFY_ENTITY_INFORMATION_OPEN",
  SET_VERIFYING_ENTITY_INFORMATION = "SET_VERIFYING_ENTITY_INFORMATION",
  SET_DYNAMIC_REQUIREMENTS_LOAD_IN_PROGRESS = "SET_DYNAMIC_REQUIREMENTS_LOAD_IN_PROGRESS",
  SET_DYNAMIC_REQUIREMENTS = 'SET_DYNAMIC_REQUIREMENTS',
  SET_JURISDICTIONS = 'SET_JURISDICTIONS'
}

export type EntityAction = {
  type: EntityActionTypeEnum.SET_ENTITIES_LOAD_IN_PROGRESS;
  data: boolean;
} | {
  type: EntityActionTypeEnum.SET_ENTITIES;
  data: EntityAttributes[];
} | {
  type: EntityActionTypeEnum.SET_SELECTED_ENTITY;
  data: EntityAttributes;
} | {
  type: EntityActionTypeEnum.SET_JOURNEY_TASKS_LOAD_IN_PROGRESS;
  data: boolean;
} | {
  type: EntityActionTypeEnum.SET_INITIAL_JOURNEY_TASKS;
  data: JourneyTaskAttributes[];
} | {
  type: EntityActionTypeEnum.SET_LATEST_JOURNEY_TASKS;
  data: JourneyTaskAttributes[];
} | {
  type: EntityActionTypeEnum.SET_SELECTED_JOURNEY_TASK;
  data: JourneyTaskAttributes;
} | {
  type: EntityActionTypeEnum.SET_DATA_GROUPS;
  data: any;
} | {
  type: EntityActionTypeEnum.SET_DATA_GROUPS_LOAD_IN_PROGRESS;
  data: boolean;
} | {
  type: EntityActionTypeEnum.SET_DOCUMENTS_LOAD_IN_PROGRESS;
  data: boolean;
} | {
  type: EntityActionTypeEnum.SET_DOCUMENTS;
  data: JourneyDocument[];
} | {
  type: EntityActionTypeEnum.SET_DOCUMENT_REQUIREMENTS_LOAD_IN_PROGRESS;
  data: boolean;
} | {
  type: EntityActionTypeEnum.SET_DOCUMENT_REQUIREMENTS;
  data: JourneyDocumentRequirements[];
} | {
  type: EntityActionTypeEnum.SET_ENTITY_DRAFT,
  data: any
} | {
  type: EntityActionTypeEnum.SET_ENTITY_DRAFT_LOAD_IN_PROGRESS,
  data: boolean
} | {
  type: EntityActionTypeEnum.SET_CODAT_INTEGRATION_LOAD_IN_PROGRESS,
  data: any
} | {
  type: EntityActionTypeEnum.SET_LOOKUPS,
  data: any
} | {
  type: EntityActionTypeEnum.SET_CODAT_INTEGRATION,
  data: any
} | {
  type: EntityActionTypeEnum.SET_LOOKUPS_LOAD_IN_PROGRESS,
  data: boolean
} | {
  type: EntityActionTypeEnum.SET_LOOKUP_LINKS,
  data: any
} | {
  type: EntityActionTypeEnum.SET_LOOKUP_LINKS_LOAD_IN_PROGRESS,
  data: boolean
} | {
  type: EntityActionTypeEnum.SET_INITITAL_REQUIREMENTS,
  data: any
} | {
  type: EntityActionTypeEnum.SET_INITITAL_REQUIREMENTS_LOAD_IN_PROGRESS,
  data: boolean
} | {
  type: EntityActionTypeEnum.SET_DOCUMENT_DOWNLOAD_URL;
  data: object;
} | {
  type: EntityActionTypeEnum.SET_DOCUMENT_DOWNLOAD_URL_LOAD_IN_PROGRESS;
  data: boolean;
} | {
  type: EntityActionTypeEnum.SET_ASSOCIATIONS;
  data: AssociationModel[];
} | {
  type: EntityActionTypeEnum.SET_ASSOCIATIONS_LOAD_IN_PROGRESS;
  data: boolean;
} | {
  type: EntityActionTypeEnum.SET_PEOPLE_ENTITIES_LIST;
  data: PeopleEntityModel[];
} | {
  type: EntityActionTypeEnum.SET_PEOPLE_ENTITIES_LIST_LOAD_IN_PROGRESS;
  data: boolean;
} | {
  type: EntityActionTypeEnum.SET_ALL_PEOPLE_ENTITIES_LIST;
  data: PeopleEntityModel[];
} | {
  type: EntityActionTypeEnum.SET_ENTITY;
  data: any;
} | {
  type: EntityActionTypeEnum.SET_DYNAMIC_REQUIREMENTS_LOAD_IN_PROGRESS;
  data: boolean;
} | {
  type: EntityActionTypeEnum.SET_VERIFY_ENTITY_INFORMATION_OPEN;
  data: boolean;
} | {
  type: EntityActionTypeEnum.SET_VERIFYING_ENTITY_INFORMATION;
  data: boolean;
} | {
  type: EntityActionTypeEnum.SET_DYNAMIC_REQUIREMENTS;
  data: any;
} | {
  type: EntityActionTypeEnum.SET_JURISDICTIONS;
  data: any;
}

export function setEntitiesLoadInProgress(entitiesLoadInProgress: boolean) {
  return {
    type: EntityActionTypeEnum.SET_ENTITIES_LOAD_IN_PROGRESS,
    data: entitiesLoadInProgress
  }
}

export function setEntities(entitiesResponse: any[]) {
  return {
    type: EntityActionTypeEnum.SET_ENTITIES,
    data: entitiesResponse
  }
}

export function setSelectedEntity(entity: EntityAttributes) {
  return {
    type: EntityActionTypeEnum.SET_SELECTED_ENTITY,
    data: entity
  }
}

export function setEntityDraftLoadInProgress(entityDraftLoadInProgress: boolean) {
  return {
    type: EntityActionTypeEnum.SET_ENTITY_DRAFT_LOAD_IN_PROGRESS,
    data: entityDraftLoadInProgress
  }
}

export function setEntityDraft(entityDraft: EntityDraftViewModel[]) {
  return {
    type: EntityActionTypeEnum.SET_ENTITY_DRAFT,
    data: entityDraft
  }
}

export function setJourneyTasksLoadInProgress(journeyTasksLoadInProgress: boolean) {
  return {
    type: EntityActionTypeEnum.SET_JOURNEY_TASKS_LOAD_IN_PROGRESS,
    data: journeyTasksLoadInProgress
  }
}

export function setInitialJourneyTasks(journeyTasks: JourneyTaskAttributes[]) {
  return {
    type: EntityActionTypeEnum.SET_INITIAL_JOURNEY_TASKS,
    data: journeyTasks
  }
}

export function setLatestJourneyTasks(journeyTasks: JourneyTaskAttributes[]) {
  return {
    type: EntityActionTypeEnum.SET_LATEST_JOURNEY_TASKS,
    data: journeyTasks
  }
}

export function setSelectedJourneyTask(journeyTask: JourneyTaskAttributes) {
  return {
    type: EntityActionTypeEnum.SET_SELECTED_JOURNEY_TASK,
    data: journeyTask
  }
}

export function setDataGroupsLoadInProgress(dataGroupsLoadInProgress: boolean) {
  return {
    type: EntityActionTypeEnum.SET_DATA_GROUPS_LOAD_IN_PROGRESS,
    data: dataGroupsLoadInProgress
  }
}

export function setDataGroups(dataGroups: any) {
  return {
    type: EntityActionTypeEnum.SET_DATA_GROUPS,
    data: dataGroups
  }
}

export function setLookupsLoadInProgress(lookupsLoadInProgress: boolean) {
  return {
    type: EntityActionTypeEnum.SET_LOOKUPS_LOAD_IN_PROGRESS,
    data: lookupsLoadInProgress
  }
}

export function setCodatIntegrationLoadInProgress(codatIntegrationLoadInProgress: boolean) {
 
  return {
    type: EntityActionTypeEnum.SET_CODAT_INTEGRATION_LOAD_IN_PROGRESS,
    data: codatIntegrationLoadInProgress
  }
}

export function setLookups(lookups: ILookupViewModel[]) {
  return {
    type: EntityActionTypeEnum.SET_LOOKUPS,
    data: lookups
  }
}
export function setCodatIntegration(integration: any) {
  return {
    type: EntityActionTypeEnum.SET_CODAT_INTEGRATION,
    data: integration
  }
}
export function setLookupLinksLoadInProgress(lookupLinksLoadInProgress: boolean) {
  return {
    type: EntityActionTypeEnum.SET_LOOKUP_LINKS_LOAD_IN_PROGRESS,
    data: lookupLinksLoadInProgress
  }
}

export function setLookupLinks(lookupLinks: ILookupViewModel[]) {
  return {
    type: EntityActionTypeEnum.SET_LOOKUP_LINKS,
    data: lookupLinks
  }
}

export function setAssociationsLoadInProgress(associationsLoadInProgress: boolean) {
  return {
    type: EntityActionTypeEnum.SET_ASSOCIATIONS_LOAD_IN_PROGRESS,
    data: associationsLoadInProgress
  }
}

export function setAssociations(associations: AssociationModel[]) {
  return {
    type: EntityActionTypeEnum.SET_ASSOCIATIONS,
    data: associations
  }
}

export function setPeopleEntitesListLoadInProgress(peopleEntitesListLoadInProgress: boolean) {
  return {
    type: EntityActionTypeEnum.SET_PEOPLE_ENTITIES_LIST_LOAD_IN_PROGRESS,
    data: peopleEntitesListLoadInProgress
  }
}

export function setPeopleEntitesList(peopleEntitesList: PeopleEntityModel[]) {
  return {
    type: EntityActionTypeEnum.SET_PEOPLE_ENTITIES_LIST,
    data: peopleEntitesList
  }
}

export function setAllPeopleEntitesList(peopleEntitesList: PeopleEntityModel[]) {
  return {
    type: EntityActionTypeEnum.SET_ALL_PEOPLE_ENTITIES_LIST,
    data: peopleEntitesList
  }
}

export function setDocumentRequirementsLoadInProgress(documentRequirementsLoadInProgress: boolean) {
  return {
    type: EntityActionTypeEnum.SET_DOCUMENT_REQUIREMENTS_LOAD_IN_PROGRESS,
    data: documentRequirementsLoadInProgress
  }
}

export function setDocumentRequirements(documentRequirements: JourneyDocumentRequirements[]) {
  return {
    type: EntityActionTypeEnum.SET_DOCUMENT_REQUIREMENTS,
    data: documentRequirements
  }
}

export function setDocumentsLoadInProgress(documentsLoadInProgress: boolean) {
  return {
    type: EntityActionTypeEnum.SET_DOCUMENTS_LOAD_IN_PROGRESS,
    data: documentsLoadInProgress
  }
}

export function setDocuments(documents: JourneyDocument[]) {
  return {
    type: EntityActionTypeEnum.SET_DOCUMENTS,
    data: documents
  }
}

export function setDocumentDownloadUrlLoadInProgress(documentDownloadUrlLoadInProgress: boolean) {
  return {
    type: EntityActionTypeEnum.SET_DOCUMENT_DOWNLOAD_URL_LOAD_IN_PROGRESS,
    data: documentDownloadUrlLoadInProgress
  }
}

export function setDocumentDownloadUrl(documentId: string, downloadUrl: string) {
  return {
    type: EntityActionTypeEnum.SET_DOCUMENT_DOWNLOAD_URL,
    data: { documentId: documentId, downloadUrl: downloadUrl }
  }
}

export function setEntity(entityData: any) {
  return {
    type: EntityActionTypeEnum.SET_ENTITY,
    data: entityData
  }
}

export function setVerifyEntityInformationOpen(verifyEntityInformationOpen: boolean) {
  return {
    type: EntityActionTypeEnum.SET_VERIFY_ENTITY_INFORMATION_OPEN,
    data: verifyEntityInformationOpen
  }
}

export function setVerifyingEntityInformation(verifyingEntityInformation: boolean) {
  return {
    type: EntityActionTypeEnum.SET_VERIFYING_ENTITY_INFORMATION,
    data: verifyingEntityInformation
  }
}

export function setDynamicRequirementsLoadInProgress(dynamicRequirementsLoadInProgress: boolean) {
  return {
    type: EntityActionTypeEnum.SET_DYNAMIC_REQUIREMENTS_LOAD_IN_PROGRESS,
    data: dynamicRequirementsLoadInProgress
  }
}

export function setDynamicRequirements(dynamicRequirements: IRequirementViewModel[]) {
  return {
    type: EntityActionTypeEnum.SET_DYNAMIC_REQUIREMENTS,
    data: dynamicRequirements
  }
}

export function setJurisdictions(dynamicJurisdictions: any[]) {
  return {
    type: EntityActionTypeEnum.SET_JURISDICTIONS,
    data: dynamicJurisdictions
  };
}